import React, {Component} from 'react'

import MaterialIcon, {colorPalette} from 'material-icons-react';
import TreeMapDelayWidget from "../../components/Widgets/TreeMapDelayWidget";
import Row from "react-bootstrap/es/Row";
import Col from "react-bootstrap/es/Col";
import HttpClient from "../../utils/HttpClient/HttpClient";
import WidgetHelper from "../../components/Helpers/WidgetHelper";
import {SortableElement, SortableContainer, arrayMove, SortableHandle } from "react-sortable-hoc";
import StaticTopDashboard from "./StaticTopDashboard";
import Widget3 from "../../components/Widgets/Widget3";
import Widget5 from "../../components/Widgets/Widget5";
import Widget1 from "../../components/Widgets/Widget1";
import Widget2 from "../../components/Widgets/Widget2";


const SortableItem = SortableElement(({value}) => {
        return (
            <li className="list-group-item bg-light">
                <DragHandle />
                {value}
            </li>
        );
    }
);

const SortableList = SortableContainer(({items}) => {
    return (
        <ul className="list-group dashboard-list">
            {items.map((value, index) => (
                <SortableItem key={`item-${index}`} index={index} value={value} />
            ))}
        </ul>
    );
});

const DragHandle = SortableHandle(() => <div className="w-100 cursor">
    <MaterialIcon icon="drag_handle"/>
</div>);

export default class DashBoardView extends Component {

    els = [];
    httpClient;
    widgetHelper;
    constructor(props){
        super(props);
        this.state = {
            widgetIds: null
        };

        this.els = [
            { id:1, name: "Detalle de rango", component: <Widget1 name="Detalle de rango" isDashboard id={1} onSelectionChange={(b, id) => this.onSelectionChange(b, id)}/> },
            { id:2, name: "Actividad de equipo", component: <Widget2 name="Actividad de equipo" isDashboard id={2} onSelectionChange={(b, id) => this.onSelectionChange(b, id)}/> },
            { id:3, name: "Detalles de afiliados", component: <Widget3 name="Detalles de afiliados" isDashboard id={3} onSelectionChange={(b, id) => this.onSelectionChange(b, id)}/> },
            { id:4, name: "Mora", component: <TreeMapDelayWidget name="Mora" isDashboard id={4} onSelectionChange={(b, id) => this.onSelectionChange(b, id)}/> },
            { id:5, name: "Detalle de cuotas por pagar", component: <Widget5 name="Detalle de cuotas por pagar" isDashboard id={5} onSelectionChange={(b, id) => this.onSelectionChange(b, id)}/> },
        ];

        this.httpClient = new HttpClient(true);
        this.widgetHelper = new WidgetHelper();
    }


    componentWillMount() {
        this.httpClient.get("oga/dashboard/widgets").then((response) => {
            console.log("oga/dashboard/widgets Success");

            let data = response.data;
            console.dir(response.data);
            this.setState({ widgetIds: data });

        }).catch((error) => {
            console.error("oga/dashboard/widgets" , error);
        })
    }

    onSelectionChange = (b, id) => {

        let index = this.state.widgetIds.indexOf(id);
        console.log(this.state.widgetIds);
        if (index > -1) {
            this.state.widgetIds.splice(index)
        }
        console.log(this.state.widgetIds);
        this.setState({widgetIds: this.state.widgetIds});
        console.log(this.state.widgetIds.indexOf(id));

        this.widgetHelper.removeWidgetById(id)
    };

    onSortEnd = ({oldIndex, newIndex}) => {
        this.setState({widgetIds: arrayMove(this.state.widgetIds, oldIndex, newIndex),});
        let newOrder = [];
        for ( let e of this.state.widgetIds) { newOrder.push(e); }
        this.httpClient.post("oga/dashboard/reorder", newOrder);
    };

    render() {
        let widgets = this.state.widgetIds;
        let length = 0;
        let loading = false;
        if (widgets){
            length = widgets.length;
        } else {
            loading = true;
        }

        let empty = length === 0;

        let loaderClass = loading ? 'fade-show' : 'fade-hide';

        let emptyClass = 'opacity-0';
        let contentClass = 'opacity-0';
        if (!loading){
            emptyClass =  empty ? 'fade-show' : 'fade-hide';
            contentClass = !empty ?'fade-show' : 'fade-hide';
        }

        let filteredWidgets = null;
        if (widgets){
            filteredWidgets = widgets.map((id) => { return  this.els.find((el) => el.id === id).component; });
        }

        return (
            <div>

                <Row>
                    <Col md={12}>
                        <h1 className="header">Dashboard</h1>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <StaticTopDashboard/>
                    </Col>
                </Row>

                {
                    loading ?
                        <Row className={loaderClass}>
                            <Col md={12}>
                                Dashboard...
                            </Col>
                        </Row>
                        :
                        <Row>
                            {/*<EmptyDashboardView className={emptyClass}/>*/}
                            <Col md={12}>
                                <div>
                                    {
                                        empty ? null :
                                            <div className={contentClass}>
                                                {
                                                    !filteredWidgets ? null : <SortableList items={filteredWidgets} onSortEnd={this.onSortEnd} useDragHandle={true}/>
                                                }
                                            </div>
                                    }
                                </div>
                            </Col>
                        </Row>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/DashBoard/DashBoardView.jsx